import React from 'react';
import { func } from 'prop-types';

const UpdateEditDilogContent = ({ onClose, updateTarget }) => {
  const _handleCancel = () => {
    onClose();
  };
  const _handleUpdate = () => {
    updateTarget();
  };
  return (
    <div className="de__unsaved--body">
      <span>
        This target’s study-weight does not match current selections. Would you
        like to update your target with the currently selected study-weight?
      </span>
      <div className="de__unsaved--actions">
        <button
          type="button"
          onClick={_handleCancel}
          className="de--btn de--btn--outline__primary"
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={_handleUpdate}
          className="de--btn de--btn__primary"
        >
          Update
        </button>
      </div>
    </div>
  );
};

UpdateEditDilogContent.propTypes = {
  onClose: func,
  updateTarget: func,
};

export default UpdateEditDilogContent;
